import { render, staticRenderFns } from "./HistoryDemands.vue?vue&type=template&id=2ac54efa&"
import script from "./HistoryDemands.vue?vue&type=script&lang=js&"
export * from "./HistoryDemands.vue?vue&type=script&lang=js&"
import style0 from "./HistoryDemands.vue?vue&type=style&index=0&id=2ac54efa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports